import * as React from 'react';
import { InfrastructureTypeRows } from 'shared/mf-infrastructure/components/TransportAccessibility';
import { useWidgetSettingsContext } from 'shared/mf-infrastructure/containers/WidgetSettingsContext';
import {
  ETransportAccessibilityTab,
  ITAInfrastructure,
  TTAInfrastructureType,
} from 'shared/mf-infrastructure/types/transportAccessibility';

import { getInsideRows } from './helpers';
import { getAnalyticsBlockType, trackInfrastructureTypeClick } from '../InfrastructureContainer/tracking';

export interface ITransportAccessibilityOutsideProps {
  rate: React.ReactNode;
  onTransportAccessibilityChange: (infrastructureType: TTAInfrastructureType | null) => void;
  transportAccessibilityInfrastructure?: ITAInfrastructure;
}

export const TransportAccessibilityInside: React.FC<ITransportAccessibilityOutsideProps> = ({
  onTransportAccessibilityChange,
  rate,
  transportAccessibilityInfrastructure,
}) => {
  const { profile } = useWidgetSettingsContext();

  const { clickableRows, nonClickableRows } = React.useMemo(
    () => getInsideRows(transportAccessibilityInfrastructure),
    [transportAccessibilityInfrastructure],
  );

  const [selectedType, setSelectedType] = React.useState(clickableRows[0]?.id);

  // Колбэк может пересоздаться после маунта (например, когда карта загрузилась позже сайдбара),
  // поэтому в cleanup зовём актуальную версию, а не захваченную при маунте.
  const onTransportAccessibilityChangeRef = React.useRef(onTransportAccessibilityChange);
  onTransportAccessibilityChangeRef.current = onTransportAccessibilityChange;

  React.useEffect(() => {
    onTransportAccessibilityChangeRef.current(selectedType as TTAInfrastructureType);

    return () => onTransportAccessibilityChangeRef.current(null);
  }, []);

  const handleRowClick = React.useCallback(
    (infrastructureType: TTAInfrastructureType) => {
      onTransportAccessibilityChange(infrastructureType);
      setSelectedType(infrastructureType);

      const blockType = getAnalyticsBlockType(ETransportAccessibilityTab.Inside, []);
      trackInfrastructureTypeClick({
        profile: profile || null,
        blockType,
        infrastructureType,
      });
    },
    [profile, onTransportAccessibilityChange],
  );

  return (
    <>
      {rate}
      <InfrastructureTypeRows
        clickableRows={clickableRows}
        nonClickableRows={nonClickableRows}
        onRowClick={handleRowClick}
        selectedItemId={selectedType}
      />
    </>
  );
};
